import {
  GetActionsDocument,
  GetActionsQuery,
  GetActionsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type ProcessesAction = NonNullable<
  GetActionsQuery['processes']['actionsConnection']['nodes'][number]
>

export const useActions = (variables: GetActionsQueryVariables) => {
  const { data, loading } = useQuery(GetActionsDocument, {
    variables,
  })

  const actions: ProcessesAction[] =
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    (data?.processes?.actionsConnection.nodes as ProcessesAction[]) || []

  return {
    loading,
    actions,
  }
}
